import { useContext, useEffect, useState } from 'react'
import moment from 'moment-timezone';
import { Box, Skeleton, Typography } from '@mui/material'
import TouMessage from './touMessage';
import { DataContext } from '../../../contexts/data/dataContext'
import custom from '../../../styles/mui/szVariables.json'

export default function EnergyFlowMessage() {
  const data: any = useContext(DataContext)
  const [ lastUpdate, setLastUpdate ] = useState(
    moment.tz(moment(data?.dashboard?.energyFlow?.lastUpdate || 
      Date.now()),'Pacific/Auckland').fromNow()
  )

  const refresh = (lastUpdate: number)=>(
      (Date.now()-lastUpdate)>(60000*5) &&
      document.visibilityState==='visible' 
    )

  let stillMounted = { value: false }
      
  const update = (lastUpdate: any, timout=30000)=>{
    if(refresh(lastUpdate)) {
      data?.refetchDashboard()
    }
    if(lastUpdate && stillMounted.value) {
      setLastUpdate(moment.tz(
        moment(lastUpdate),'Pacific/Auckland'
      ).fromNow())
      setTimeout(()=>{
        update(lastUpdate)
      }, timout)
    }
  }

  useEffect(()=>{
    const lastUpdate = data?.dashboard?.energyFlow?.lastUpdate
    if(refresh(lastUpdate)) {
      data?.refetchDashboard()
    }
    stillMounted.value = true  
    update(lastUpdate, 0)
    return ()=>{ stillMounted.value = false}
  },[data?.dashboard?.energyFlow?.lastUpdate])

  if(!data?.dashboard?.energyFlow) 
    return (
      <Box my={1}  mx={2} width="100%" >
        <Skeleton variant="rectangular" 
          sx={{ borderRadius: '16px',  
          height: "20vh"
        }}/>
      </Box>
    )

  return (
    <Box width="100%" id="energyFlowMessage"
        sx={{ 
          backgroundColor: 'sz.colors.background' 
        }}
        ml={{
          xs: 0,
          sm: custom.spacing.md,
          md: data?.rightPanel?0:custom.spacing.md,
          lg: custom.spacing.md
        }}
        >
        <Typography id="energyFLowUpdatedAgo" 
            variant="szBody.Regular.xSmall" 
            sx={{  color: 'sz.colors.gray600'}}>
              {lastUpdate}
        </Typography>
        {!data?.dashboard?.tou ?    
          <Box mt={custom.spacing.xxs} width="100%">
            <Typography id="energyFlowTitle" 
                variant="szHeading.Bold.xLarge"  >
                {data?.dashboard?.energyFlow?.operation?.title || 'Energy Flow'}
            </Typography>
            <Typography id="energyFlowDesc" 
                component="p" variant="szBody.Regular.Medium" >
                {data?.dashboard?.energyFlow?.operation?.description || ''}
            </Typography>
          </Box>
        :
          <TouMessage />
        }
    </Box>      
  )
}
